module.exports = __webpack_public_path__ + "static/media/canon.8742217.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/ware-2018/canon.mp3
// module id = tN6d
// module chunks = 0